"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var useKeyPress_1 = require("../../utils/useKeyPress");
var MBText_1 = require("../MBText");
var StyledKeyboardButton = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: #000;\n  color: #fff;\n  border: 1px solid #000;\n  border-radius: 4px;\n  padding: 2px 4px;\n\n  white-space: nowrap;\n\n  transition: 0.2s all ease-in-out;\n\n  ", "\n"], ["\n  box-sizing: border-box;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: #000;\n  color: #fff;\n  border: 1px solid #000;\n  border-radius: 4px;\n  padding: 2px 4px;\n\n  white-space: nowrap;\n\n  transition: 0.2s all ease-in-out;\n\n  ",
    "\n"])), function (_a) {
    var pressed = _a.pressed;
    return pressed &&
        "\n  color: #000;\n  background: #fff;\n  ";
});
var KeyboardButton = function (_a) {
    var targetKey = _a.targetKey, shouldListen = _a.shouldListen;
    var pressed = useKeyPress_1.useKeyPress({
        targetKey: targetKey,
        enabled: shouldListen !== null && shouldListen !== void 0 ? shouldListen : false,
    });
    var renderLabel = function () {
        switch (targetKey) {
            case 'Escape':
                return 'ESC';
            default:
                return targetKey;
        }
    };
    return (jsx_runtime_1.jsx(StyledKeyboardButton, __assign({ pressed: pressed }, { children: jsx_runtime_1.jsx(MBText_1.MBText, __assign({ variant: "labelTiny" }, { children: renderLabel() }), void 0) }), void 0));
};
exports.KeyboardButton = KeyboardButton;
var templateObject_1;
//# sourceMappingURL=KeyboardButton.js.map